import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { ErrorTagName, ErrorTagValue } from 'src/shared/constants/ErrorTag';

const useErrorTag = (tagName: ErrorTagName, value?: ErrorTagValue) => {
  useEffect(() => {
    if (value) {
      Sentry.setTag(tagName, value);
    }

    return () => Sentry.setTag(tagName, undefined);
  }, [tagName, value]);
};

export { useErrorTag };
